export const normalizePath = value => value.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';

// Preserve the server-rendered hero while React adds forms and interactions.
// Public HTML carries only this page's metadata, rather than every page template.
export const initialTemplate = document.querySelector('#root > .redesign-template');
const metadata = document.getElementById('page-data');
export const initialPage = metadata && initialTemplate ? {
  ...JSON.parse(metadata.textContent),
  post: JSON.parse(document.querySelector('[data-live-slot="article"]')?.dataset.initialContent || 'null'),
  pathname: normalizePath(window.location.pathname),
  title: document.title,
  description: document.querySelector('meta[name="description"]')?.content || '',
  image: document.querySelector('meta[property="og:image"]')?.content || '',
} : null;
